<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Liên kết</h4>
          </template>
          <template v-slot:body>
            <div>
              <link-attach/>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<style type="text/css">
.customer-table .vs__selected {
  min-width: 140px;
}
</style>
<script>
import { findash } from '../../config/pluginInit'
import LinkAttach from '../../components/application/link/LinkAttach'

export default {
  name: 'LinkList',
  components: { LinkAttach },
  async mounted () {
    findash.index()
  },
  data () {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
